import "../src/styles/main.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function Maintenance() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <p>Site en maintenance, de retour bientôt !</p>
    </div>
  )
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<Maintenance />} />
      </Routes>
    </Router>
  );
}

export default App;